import React from "react";
import quot from "../../../assets/media/icon/quot.svg";
import rating5 from "../../../assets/media/icon/rating-5.svg";
import avatar from "../../../assets/media/img/avatar.svg";

const TestemonialCard = ({ message, name, badge, av }) => {
  return (
    <div className="max-w-sm border border-primary-50 dark:border-none dark:bg-accent-800 w-full rounded-xl shadow-lg">
      <div className="p-25px flex flex-col gap-16px">
        <img className="max-w-[32px]" src={quot} alt="" />
        <p className="text-accent-500 dark:text-accent-400">{message}</p>
        <div className="flex items-end justify-between">
          <div className="flex items-center gap-16px text-sm">
            <img src={avatar} alt="" />
            <div className="">
              <div className="font-semibold text-primary-900 dark:text-accent-300">
                {name}
              </div>
              <div className="text-accent-400 dark:text-accent-400">
                {badge}
              </div>
            </div>
          </div>
          <img src={rating5} alt="" />
        </div>
      </div>
    </div>
  );
};

export default TestemonialCard;
